import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
// api
import Api from '@/api'
import {AppType} from '@/enum'
import {IsManagerPro} from '@/utils'


/**
 * 金蝶表单项
 * @constructor
 */
const KingDeeFormItems = () => {

  return (
    <>
      <ProFormText
        name={["config", "dCID"]}
        label={"dCID"}
        placeholder={"请输入dCID"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入dCID"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={['config', 'lCID']}
        label={"lCID"}
        placeholder={"请输入lCID"}
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入lCID"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={['config', 'userName']}
        label={"userName"}
        placeholder={"请输入userName"}
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入userName"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={["config", "appId"]}
        label={"appId"}
        placeholder={"请输入appId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      /> 
      <ProFormText
        name={["config", "appSecret"]}
        label={"appSecret"}
        placeholder={"请输入appSecret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appSecret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      /> 
      <ProFormText
        name={["config", "serverUrl"]}
        label={"serverUrl"}
        placeholder={"请输入serverUrl,若为公有云则不填"}
        width={"lg"}
        rules={[
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />      
    </>
  )
}

export default KingDeeFormItems
